module.exports = __webpack_public_path__ + "img/company_slogan.d4b1d802.png";